<template>
  <div class="icon-wrapper" @mouseleave="hideActiveIcon">
    <div
      class="icon-inner"
      :class="{ isIconActive }"
      @mouseenter="showActiveIcon"
    >
      <slot />
      <Icon :icon="appliedIcon" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { IconType } from "@/types/icons";
import Icon from "@/components/icons/Icon/Icon.vue";

interface DesktopReactionsControlsItemProps {
  activeIcon: IconType;
  inactiveIcon: IconType;
  currentIcon: IconType | null;
}

interface Emits {
  (e: "toggleActiveIcon", icon: IconType): void;
  (e: "onActiveIconChange"): void;
}

const emit = defineEmits<Emits>();

const props = defineProps<DesktopReactionsControlsItemProps>();
const isIconActive = computed(() => props.currentIcon === props.activeIcon);

const appliedIcon = computed(() => {
  if (isIconActive.value) {
    return props.activeIcon;
  }

  return props.inactiveIcon;
});

const showActiveIcon = () => {
  emit("toggleActiveIcon", props.activeIcon);
  emit("onActiveIconChange");
};

const hideActiveIcon = () => {
  emit("toggleActiveIcon", props.inactiveIcon);
};
</script>

<style lang="scss">
@import "./DesktopReactionsControlsItem.scss";
</style>
